<template>
<div>
  <div slot="header" class="clearfix" style="text-align: center;">
    <Input v-model="queryStr" placeholder="请输入关键词" @on-change="init" style="width:160px;"></Input>
    <Select v-model="domainid" placeholder="选择表单" @on-change="changeDomain" clearable style="width:160px;">
      <Option v-for="(domain, key) in domains" :key="key" :value="key">{{ domain }}</Option>
    </Select>
    <Select v-model="varid" placeholder="选择变量" @on-change="init" clearable style="width:160px;">
      <Option v-for="item in variables" :key="item.id" :value="item.id">{{ item.label }}</Option>
    </Select>
    <Select v-model="status" placeholder="状态" @on-change="init" clearable style="width:110px;">
      <Option v-for="(status, key) in statuses" :key="key" :value="key">{{ status }}</Option>
    </Select>
    <Select v-model="type" placeholder="类型" @on-change="init" clearable style="width:110px;">
      <Option v-for="(type, key) in types" :key="key" :value="key">{{ type }}</Option>
    </Select>
  </div>
  <Table stripe :columns="attributes" :data="querys" v-if="querys">
    <template slot-scope="{ row }" slot="subject">
      <div class="">CRF版本：{{ row.crfName }}</div>
      <div class="">{{ row.subjid }}</div>
    </template>
    <template slot-scope="{ row }" slot="variable">
      <div class="">{{ row.visitName }}</div>
      <div class="">{{ row.domainName }}</div>
      <div class="">{{ row.varName }}</div>
    </template>
    <template slot-scope="{ row }" slot="status">
      <Tag :color="row.status === 1 ? 'error' : row.status === 2 ? 'warning' : 'success'">
        {{row.statusText}}
      </Tag>
    </template>
    <template slot-scope="{ row }" slot="action">
      <Button icon="ios-redo" @click="answer(row.id)" v-if="row.status === 1"></Button>
      <Button icon="ios-power" @click="close(row.id)" v-if="row.status === 2"></Button>
      <Button icon="ios-eye" @click="view(row)"></Button>
    </template>
  </Table>
  <pagination v-bind:meta="pageMeta" name="pagination"
  v-if="pageMeta.pageCount > 1" @refresh="init"></pagination>

  <Modal v-model="showAnswer" title="答复疑问" :footer-hide="true" width="30">
    <Form ref="domain">
      <FormItem prop="answer">
        <Input v-model="content" type="textarea" required></Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleSubmit('domain')" style="width: 100%;">提交</Button>
      </FormItem>
    </Form>
  </Modal>

  <Modal v-model="showDomain" :title="domainTile" :footer-hide="true" width="60">
    <domain-data :query="model" ref="showDomain"></domain-data>
  </Modal>

</div>
</template>

<script>
import Pagination from '@/components/share/Pagination'
import DomainData from '@/components/query/DomainData'
import { ListQuerys, CloseQuery, AnswerQuery, GetAssistItems, ListDomainVariables } from '@/api/query'

export default {
  name: 'list-querys',
  data: function () {
    return {
      id: null,
      domainid: null,
      visitid: null,
      varid: null,
      usubjid: null,
      querys: [],
      pageMeta: {},
      queryStr: '',
      selectId: null,
      content: '',
      status: '1',
      statuses: {},
      type: null,
      types: {},
      model: {},
      domains: {},
      variables: {},
      showAnswer: false,
      showDomain: false,
      domainTile: '表单数据',
      attributes: [
        { title: '受试者', key: 'subjid', width: 160, slot: 'subject' },
        { title: '变量', key: 'varName', width: 160, slot: 'variable' },
        { title: '类型', key: 'typeText', width: 120 },
        { title: '状态', key: 'statusText', width: 120, slot: 'status' },
        { title: '问题', key: 'question' },
        { title: '操作', width: 160, slot: 'action' }
      ]
    }
  },
  props: ['items', 'vid'],
  components: {
    'pagination': Pagination,
    'domain-data': DomainData
  },
  watch: {
    vid: function () {
      this.id = this.vid
      this.init()
    }
  },
  mounted: function () {
    this.id = this.vid
    this.init()
    this.getItems()
  },
  methods: {
    init: function () {
      var query = {}
      query['page'] = this.pageMeta.currentPage
      query['queryStr'] = this.queryStr
      query['QuerySearch[studyid]'] = this.$route.params.id
      query['QuerySearch[domainid]'] = this.domainid
      query['QuerySearch[visitid]'] = this.visitid
      query['QuerySearch[varid]'] = this.varid
      query['QuerySearch[status]'] = this.status
      query['QuerySearch[type]'] = this.type
      ListQuerys(query).then(async res => {
        this.querys = res.items
        this.pageMeta = res._meta
      })
    },
    getItems: function () {
      GetAssistItems().then(async res => {
        this.statuses = res.statuses
        this.types = res.types
        this.domains = res.domains
      })
    },
    handleSubmit: function (name) {
      if (this.content) {
        this.postForm()
      } else {
        this.$Message.config({
          top: 70,
          duration: 3
        })
        this.$Message.error({
          content: '必须填写答复意见'
        })
      }
    },
    postForm: function () {
      var data = {
        id: this.selectId,
        answer: this.content
      }
      AnswerQuery(data).then(async res => {
        if (res.id) {
          this.showAnswer = false
          this.init()
          this.$emit('refresh')
        }
      })
    },
    answer: function (id) {
      this.selectId = id
      this.showAnswer = true
    },
    close: function (id) {
      CloseQuery(id).then(async res => {
        this.init()
        this.$emit('refresh')
      })
    },
    view: function (model) {
      this.domainTile = model.visitName + ' #' + model.domainName
      this.$refs.showDomain.init(model)
      this.showDomain = true
    },
    changeDomain: function (value) {
      this.init()
      this.getVars(value)
    },
    getVars: function (value) {
      ListDomainVariables(value).then(async res => {
        this.variables = res
      })
    }
  }
}
</script>
